<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-stack position-left"></i>
            <span class="text-semibold">Transactions</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <a [routerLink]="['/transactionadd']" type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-add position-left"></i> Add Transaction</a>
            <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-left:30px;">
      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: Status</span>
        <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
          class="form-control">
          <option value="" selected>All</option>
          <option value="&status=pending">Pending</option>
          <option value="&status=confirmed">Confirmed</option>
          <option value="&status=declined">Declined</option>
        </select>
      </div>

      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: Type</span>
        <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
          class="form-control">
          <option value="&status=" selected>All</option>
          <option value="&type=deposit">Deposit</option>
          <option value="&type=fine">Fine</option>
          <option value="&type=award">Award</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div>

    <div class="panel-body">
      <table class="table datatable-column-search-inputs">
        <thead>
          <tr>
            <th>#</th>
            <th>Equb</th>
            <th>User</th>
            <th>Type</th>
            <th>Transaction Date</th>
            <th>Transaction Number</th>
            <th>Bank</th>
            <th>Account</th>
            <th>Amount</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let transaction of transactions | paginate: { id: 'transactions',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
            <td>{{transaction.no}}</td>
            <td><a [routerLink]="['/transaction',transaction.id]">
                {{transaction.ekub.data.ekub_id}} - {{transaction.code}}</a></td>
            <td>{{transaction.user.data.username}}</td>
            <td><span class="text-uppercase"
                [ngClass]="{'text-danger': transaction.type == 'fine', 'text-primary': transaction.type == 'deposit','text-brown': transaction.type == 'award' }">{{transaction.type}}</span>
            </td>
            <!-- <td>{{transaction.posted_date|date:short}}</td> -->
            <td>{{transaction.transaction_date|date:short}}</td>
            <td>{{transaction.transaction_number}}</td>
            <td class="text-uppercase">{{transaction.ekub?.data?.account?.data?.accronym}}</td>
            <td>{{transaction.ekub?.data?.account?.data?.account_number}}</td>
            <td>{{transaction.amount}} ETB</td>
            <td>
              <span class="label label-block label-default"
                *ngIf="transaction.status === 'Pending' || transaction.status === 'pending'">{{transaction.status}}</span>
              <span class="label label-block label-primary"
                *ngIf="transaction.status === 'Confirmed' || transaction.status === 'confirmed'">{{transaction.status}}</span>
              <span class="label label-block label-danger"
                *ngIf="transaction.status === 'Declined' || transaction.status === 'declined'">{{transaction.status}}</span>
            </td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a href="" [routerLink]="['/transactionadd']"
                        [queryParams]="{'id':transaction.id, 'ekub':transaction.ekub.data.id}">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li>
                      <a href="">
                        <i class="icon-file-excel"></i>Delete</a>
                    </li>
                    <li class="dropdown-submenu dropdown-submenu-left">
                      <a href="javascript:void(0);">Change Status</a>
                      <ul class="dropdown-menu">
                        <li>
                          <a (click)="changeStatus(transaction.id,'pending')">
                            <i class="icon-shuffle"></i> Pending</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(transaction.id,'confirmed')">
                            <i class="icon-shuffle"></i> Confirmed</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(transaction.id,'declined')">
                            <i class="icon-shuffle"></i> Declined</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="transactions.length <=0">
            <td colspan="11" class="text-center"> <i class="icon-info22">&nbsp;</i>No Transactions yet!</td>
          </tr>
        </tbody>
      </table>

      <br>

      <div class="row">
        <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
        <div class="text-center">

          <pagination-controls id="transactions" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>

          <br>
        </div>

      </div>


    </div>
  </div>
</div>